import { ResponsiveContainer, PieChart, Pie, Tooltip, Cell } from 'recharts';

export const ScoreCard = ({ title, data, totalVul, criticalVul, saveScore }) => {
  // Optional color palette for better visuals
  const COLORS = ['#ff4d4f', '#faad14', '#52c41a', '#1890ff'];

  return (
    <div className="mb-3">
      <div
        className="card p-4 rounded-4 shadow-sm text-white border-0"
        style={{ backgroundColor: '#343a40', width: 360, height: 200 }}
      >
        <div className="d-flex flex-column justify-content-between h-100">
          {/* Header with Title & Small Pie Chart */}
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="mb-0">{title}</h4>
            <div style={{ width: 60, height: 60 }}>
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={data}
                    dataKey="value"
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    innerRadius={15}
                    outerRadius={25}
                    paddingAngle={2}
                  >
                    {data.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Score Info */}
          <div className="pt-2">
            <div className="d-flex justify-content-between">
              <span className="fw-light">Vulnerability</span>
              <span className="fw-semibold">{totalVul || 0}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span className="fw-light">Critical Vulnerability</span>
              <span className="fw-semibold">{criticalVul || 0}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span className="fw-light">Save Score</span>
              <span className="fw-semibold">{saveScore || 0}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};